const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
const BASENAME = window.location.origin;
const REDIRECT_URI = `${BASENAME}/login/callback`;

export default {
  auth0: {
    domain: DOMAIN,
    clientId: CLIENT_ID,
    redirectUri: REDIRECT_URI,
    audience: AUDIENCE,
    scope: 'openid profile email offline_access',
    cacheLocation: 'localstorage',
    useRefreshTokens: true
  }
};